module.exports = __webpack_public_path__ + "static/media/ar.b2d1053b.png";